export default "__VITE_ASSET__68efe0d1__"